"use strict";
/**
 * Swiper carousel conditional loading
 * Only loads Swiper if elements with .swiper class exist on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
window.addEventListener("load", () => {
    const swiperElements = document.getElementsByClassName("swiper");
    if (swiperElements.length > 0) {
        import("swiper").then(({ Swiper }) => {
            import("swiper/css");
            // Make Swiper globally available
            globalThis.Swiper = Swiper;
            // Dispatch event for template-specific initialization
            const event = new CustomEvent("swiper-loaded", { bubbles: true });
            window.dispatchEvent(event);
        });
    }
});
